import { FormField, SingleSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";
import PanoramaIcon from "@mui/icons-material/Panorama";

const EnvironmentLighting = observer(() => {
	const store = useSnapshotTemplateStore();
	const { 
		environments,
		selectedEnvironment,
		setSelectedEnvironment,
	} = store;

	return (
		<FormField
			control={(
				<SingleSelect
					ImageProps={{
						noImageComponent: <PanoramaIcon />,
					}}
					onChange={setSelectedEnvironment}
					options={environments}
					placeHolderRes="3DEnvironment"
					slimCard
					value={selectedEnvironment}
				/>
			)}
			fullWidth
			label={<Text bold res="3DEnvironment" />}
			labelPlacement="top"
			required
			sx={REQUIRED_LABEL}
		/>
	);
});

export default EnvironmentLighting;
